"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sin = exports.cos = exports.turn = exports.grid = exports.rotY = exports.rotX = exports.sineLike = exports.distance = exports.isTimeZero = exports.closeEnough = exports.getIndexWrapped = exports.wrapIndex = exports.betterMod = exports.lerp = exports.max = exports.min = exports.cycle = exports.clamp = exports.clamp1 = exports.TIME_ZERO_EPSILON = void 0;
var assert_sidecar_1 = require("./assert-sidecar");
exports.TIME_ZERO_EPSILON = 0.00001;
var clamp1 = function (v) {
    return exports.clamp(v, 0, 1);
};
exports.clamp1 = clamp1;
var clamp = function (v, min, max) {
    if (v < min) {
        v = min;
    }
    if (v > max) {
        v = max;
    }
    return v;
};
exports.clamp = clamp;
var cycle = function (v) {
    return v - Math.floor(v);
};
exports.cycle = cycle;
var min = function (a, b) {
    return a < b ? a : b;
};
exports.min = min;
var max = function (a, b) {
    return a > b ? a : b;
};
exports.max = max;
var lerp = function (a, b, t) {
    return (1 - t) * a + t * b;
};
exports.lerp = lerp;
var betterMod = function (v, m) {
    return ((v % m) + m) % m;
};
exports.betterMod = betterMod;
var wrapIndex = function (v, arr) {
    return exports.betterMod(v, arr.length);
};
exports.wrapIndex = wrapIndex;
var getIndexWrapped = function (v, arr) {
    assert_sidecar_1.assert.t(arr.length > 0, 'array has no elements!');
    return arr[exports.betterMod(v, arr.length)];
};
exports.getIndexWrapped = getIndexWrapped;
var closeEnough = function (a, b, e) {
    return Math.abs(a - b) < e;
};
exports.closeEnough = closeEnough;
var isTimeZero = function (t) {
    return exports.closeEnough(t, 0, exports.TIME_ZERO_EPSILON);
};
exports.isTimeZero = isTimeZero;
var distance = function (x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
};
exports.distance = distance;
var sineLike = function (t, scale, min, max) {
    var dHalf = (max - min) / 2;
    var v = min + dHalf + Math.sin(t * scale) * dHalf;
    return v;
};
exports.sineLike = sineLike;
// see: https://matthew-brett.github.io/teaching/rotation_2d.html
var rotX = function (x, y, rot) {
    return Math.cos(rot) * x - Math.sin(rot) * y;
};
exports.rotX = rotX;
var rotY = function (x, y, rot) {
    return Math.sin(rot) * x + Math.cos(rot) * y;
};
exports.rotY = rotY;
var grid = function (gridSize, v) {
    v = Math.round(v / gridSize);
    v *= gridSize;
    return v;
};
exports.grid = grid;
var turn = function (turns) {
    if (turns === void 0) { turns = 0; }
    return turns * Math.PI * 2;
};
exports.turn = turn;
var cos = function (rad) {
    if (rad === void 0) { rad = 0; }
    return Math.cos(rad);
};
exports.cos = cos;
var sin = function (rad) {
    if (rad === void 0) { rad = 0; }
    return Math.sin(rad);
};
exports.sin = sin;
